<template>
  <div>
    <!-- Bandeau orange : impersonation active -->
    <div v-if="shouldShowBanner" class="impersonation-banner">
      <v-icon color="white" class="mr-2">support_agent</v-icon>
      <div class="impersonation-banner__content">
        <span class="impersonation-banner__text">
          <strong>Impersonation active<span class="d-none d-sm-inline"> — ne rien modifier</span></strong>
          <span class="d-none d-sm-inline">— vous consultez les données de</span>
          <span class="d-sm-none">·</span>
          <strong>{{ targetLabel }}</strong>
          <span v-if="hublotAdminId" class="impersonation-banner__admin d-none d-sm-inline">
            (votre ID admin : <strong>#{{ hublotAdminId }}</strong>)
          </span>
        </span>
        <v-btn
          small
          outlined
          color="white"
          :loading="impersonateLoading"
          :title="isMobile ? 'Arrêter l\'impersonation' : undefined"
          @click="stopImpersonate"
        >
          <v-icon :left="!isMobile" small>logout</v-icon>
          <span class="d-none d-sm-inline">Arrêter l'impersonation</span>
        </v-btn>
      </div>
    </div>

    <!-- Bandeau rouge : compte supprimé -->
    <div v-if="showNoAccountBanner" class="impersonation-banner impersonation-banner--error">
      <v-icon color="white" class="mr-2">warning</v-icon>
      <div class="impersonation-banner__content">
        <span class="impersonation-banner__text">
          <strong>Vous n'avez plus de compte {{ contextLabel }} !</strong>
        </span>
        <v-btn
          small
          outlined
          color="white"
          :loading="restoreLoading"
          :title="isMobile ? 'Réactiver mon compte' : undefined"
          @click="restoreAccount"
        >
          <v-icon :left="!isMobile" small>person_add</v-icon>
          <span class="d-none d-sm-inline">Réactiver mon compte</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import MobileMixin from '@/mixins/MobileMixin'

  export default {
    name: 'ImpersonationBanner',
    mixins: [MobileMixin],
    data() {
      return {
        restoreLoading: false,
      }
    },
    computed: {
      shouldShowBanner() {
        const adminId = this.$store.getters.hublotAdminId
        const clientId = this.$store.getters.currentClientIdInToken
        return adminId && clientId && String(adminId) !== String(clientId)
      },
      showNoAccountBanner() {
        return this.$store.getters.isHublotAdmin && !this.$store.getters.hasCurrentAccount
      },
      currentClientIdInToken() {
        return this.$store.getters.currentClientIdInToken
      },
      hublotAdminId() {
        return this.$store.getters.hublotAdminId
      },
      impersonateLoading() {
        return this.$store.getters.impersonateLoading
      },
      targetCustomer() {
        return this.$store.getters.impersonateTargetCustomer
      },
      targetLabel() {
        const enseigne = this.targetCustomer?.enseigne
        const name = this.targetCustomer?.name || this.targetCustomer?.nom
        const id = this.currentClientIdInToken
        const label = enseigne && name ? `${enseigne} — ${name}` : (name || enseigne)
        if (label && id) return `${label} (#${id})`
        if (label) return label
        return `#${id}`
      },
      contextLabel() {
        return this.$store.state.home.app === 'carnot' ? 'Boucherie' : 'Poissonnerie'
      },
    },
    methods: {
      stopImpersonate() {
        this.$store.dispatch('stopImpersonate')
          .catch(() => {})
      },
      restoreAccount() {
        this.restoreLoading = true
        this.$store.dispatch('restoreOwnAccount')
          .catch(() => {})
          .finally(() => { this.restoreLoading = false })
      },
    },
  }
</script>

<style lang="scss" scoped>
.impersonation-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background-color: var(--warning);
  color: var(--on-brand);
}

.impersonation-banner--error {
  background-color: var(--danger);
}

.impersonation-banner__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.impersonation-banner__text {
  flex: 1;
  min-width: 0;
}

/* Petit écran : la bannière garde ses 40 px (la barre d'outils et les tiroirs sont calés dessus) :
   une seule ligne, le texte secondaire disparaît et le bouton ne garde que son icône */
@media (max-width: 959.98px) {
  .impersonation-banner {
    padding: 0 var(--space-3);
  }
  .impersonation-banner__content {
    gap: var(--space-2);
  }
  .impersonation-banner__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .impersonation-banner .v-btn {
    flex: none;
  }
  /* Le bouton tactile de 40 px remplirait toute la hauteur du bandeau */
  .impersonation-banner .v-btn.v-size--small {
    height: 32px !important;
  }
}
</style>
